import "./detials.css"
import { useNavigate } from "react-router-dom";

function FourServices(){
              const navigate = useNavigate();
    
    return(
        <>
        <div className="servicedetials">
            <div className="row">
                <div className="col-md-12">
<div className="box">
    <i className="fas fa-baby"></i>
    <h4>Pediatric Intensive Care Unit</h4>
    <p>
        Provides specialized medical care for newborns and children up to five years old in a sterile and safe environment, equipped with continuous cardiac and respiratory monitoring. The team includes pediatricians and consultants in pediatric pulmonary and cardiac diseases, supported by a nursing staff trained to handle critical cases and deliver nutritional and respiratory support.
    </p>
    <p>April 28, 2025</p>
</div>
                </div>
            </div>
           <div className="row  m-2">
   <div className="buttons">
  
     <button
      className="btn w-100 btn-warning m-2"
      onClick={() => navigate(-1)}
    >
      <i className="fas fa-exclamation-triangle w-100"></i>
      Return to Service
    </button>

  
  </div>
</div>
        </div>
        </>
    )
}
export default FourServices